import React from 'react';

import { LoadingNavigation } from './components/loading-navigation/loading-navigation';
import * as styled from './loading-app.styled';
import { CustomSkeleton } from '@components/loading/custom-skeleton/custom-skeleton';
import { LoadingRoute } from '@components/loading/loading-route/loading-route';

export const LoadingApp = () => {
    return (
        <styled.container>
            <styled.wrapper>
                <CustomSkeleton {...styled.header} />
                <LoadingNavigation />
            </styled.wrapper>
            <LoadingRoute isLoadingApp={true} />
        </styled.container>

    );
};
